<template>
  <div class="window payment-window add-new-payment-window" v-show="isVisible">
    <span class="close" title="Закрыть" @click="$emit('close-window', false)"><img src="../image/cancel.svg"></span>
    <div class="window-title">{{ isNew ? 'Добавить' : 'Редактировать' }} предоплату</div>
    <div class="form">
      <div class="payment-main-info">
        <div class="visibility">
          <fieldset class="date">
            <fieldset>
              <date-picker
                      v-model="date"
                      ref="datePicker"
                      format="DD.MM.YYYY"
                      lang="ru"
                      v-mask="'##.##.####'"
                      placeholder="__.__.____"
                      :clearable="false"
                      :first-day-of-week="1">
              </date-picker>
            </fieldset>
          </fieldset>
          <fieldset class="summ">
            <input type="number" v-model="amount" :min="minPrepaymentAmount">
            <span>руб.</span>
          </fieldset>
        </div>
        <div class="text">Минимальная сумма предоплаты - {{ minPrepaymentAmount }} руб.</div>
      </div>

      <div class="buttons">
        <button type="button" class="save-button" @click="saveChanges">Сохранить</button>
      </div>
    </div>
  </div>
</template>
<script>
  import Constants from '@/constants.js'
  import DatePicker from 'vue2-datepicker'
  import {mask} from 'vue-the-mask'
  import utils from '@/utils'

  export default {
  name: 'Prepayment',
  props: ['isVisible', 'isNew', 'index'],

  components: {
    DatePicker
  },

    directives: {mask},

  data () {
    return {
      minPrepaymentAmount: Constants.MIN_PREPAYMENT_AMOUNT,

      amount: Constants.MIN_PREPAYMENT_AMOUNT,

      prepayment: {
        amount: Constants.MIN_PREPAYMENT_AMOUNT,
        dateTime: new Date()
      },

      newPrepayment: {
        amount: Constants.MIN_PREPAYMENT_AMOUNT,
        dateTime: new Date()
      }
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        if (this.isNew) {
          this.newPrepayment = {
            amount: Constants.MIN_PREPAYMENT_AMOUNT,
            dateTime: new Date(),
            prepayment: true
          }
          this.amount = this.newPrepayment.amount
        } else {
          this.prepayment = this.$store.state.prepayments[this.index]
          this.amount = this.prepayment.amount
        }
      }
    }
  },

  computed: {
    date: {
      get () {
        if (this.isNew) { return this.newPrepayment.dateTime } else { return this.prepayment.dateTime }
      },

      set (date) {
        let timestamp = date ? date.getTime() : new Date();
        if (this.isNew) { this.newPrepayment.dateTime = timestamp } else { this.prepayment.dateTime = timestamp }
      }
    }
  },

  methods: {
    syncAmount (amount) {
      let amountNumber = Number(amount)
      if (amountNumber == NaN || amountNumber < Constants.MIN_PREPAYMENT_AMOUNT) {
        return false
      }

      if (this.isNew) { this.newPrepayment.amount = amountNumber } else { this.prepayment.amount = amountNumber }

      return true
    },

    saveChanges () {
      if (!this.syncAmount(this.amount)) {
        alert('Пожалуйста, выберите значение не менее ' + Constants.MIN_PREPAYMENT_AMOUNT + '.')
        return
      }

      if (this.isNew) { this.addNewPrepayment() } else { this.updatePrepayment() }
      this.$emit('close-window', false)
    },

    updatePrepayment () {
      this.$store.commit('updatePrepaymentByIndex', {
        index: this.index,
        prepayment: this.prepayment
      })
    },

    addNewPrepayment () {
      this.$store.commit('addNewPrepayment', this.newPrepayment)
    },

    addDatePickerWatcher() {
      // нужен для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

      this.$watch(
        () => {
          return this.$refs.datePicker.userInput
        },
        (newVal, oldVal) => {
          let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
          if (tmpValueForDatePicker) {
            this.date = tmpValueForDatePicker;
            this.$refs.datePicker.popupVisible = false;
          } else if (tmpValueForDatePicker === null) {
            this.$refs.datePicker.userInput = '';
            this.$refs.datePicker.currentValue = null;
          }
        }
      );
    }
  },

    mounted() {
      this.addDatePickerWatcher();
  }
}
</script>
